import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

export default Image.extend({
  name: 'custom-image',

  defaultOptions: {
    ...Image.options,
    sizes: ['icon', 'extra-small', 'small', 'medium', 'large', 'extra-large'],
  },

  addAttributes() {
    return {
      ...Image.config.addAttributes(),
      size: {
        default: 'large',
        rendered: false,
      },
      float: {
        default: 'center',
        rendered: false,
      },
    }
  },

  addCommands() {
    return {
      setImage:
        (options) =>
        ({ tr, commands }) => {
          if (tr.selection?.node?.type?.name === 'custom-image') {
            return commands.updateAttributes('custom-image', options)
          }

          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
      getImageSRC:
        (options) =>
        // eslint-disable-next-line consistent-return
        ({ tr }) => {
          if (tr.selection?.node?.type?.name === 'custom-image') {
            return tr.selection?.node.attrs.src
          }
        },
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    HTMLAttributes.class = ` custom-image-${node.attrs.size}`
    HTMLAttributes.class += ` custom-image-float-${node.attrs.float}`

    return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
  },
})
